import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo_dark.png";
import { Check } from "lucide-react";
import "./LeftContent.scss";

interface LeftContentProps {
  showStartNowButton?: boolean;
  startNowButtonPath?: string;
  hideLogo?: boolean;
}

const LeftContent = ({
  showStartNowButton = false,
  startNowButtonPath = "/signup",
  hideLogo = false,
}: LeftContentProps) => {
  const navigate = useNavigate();

  return (
    <div className="left-wrapper">
      <div className="left-container">
       {!hideLogo && <div className="left-side-logo-container-miniscreen">
            <img src={logo} alt="logo" className="left-side-logo" />
        </div>}
        <div className="headline-section">
          <h2 className="headline-title">
            Real-Time Video Collaboration for Post-Production
          </h2>
          <p>
            Stream, review, and approve editorial content with sub-second
            latency. Securely collaborate from anywhere with studio-grade
            encryption and video conferencing.
          </p>
        </div>

        <div className="price-section">
          <span className="price">$99</span>
          <span className="per-month">/mo</span>
        </div>

        <p className="description">
          Access to PacPost.io for remote viewing and collaboration. Securely
          stream editorial with anyone, anywhere.
        </p>

        <div className="features-section">
          {[
            "Avid SRT Plugin",
            "OBS WebRTC NDI Support",
            "Google Chrome browser support",
            "Email Support Only",
            "1 Passphrase-protected room per account",
            "Up to 10 participants per room with Video Conferencing",
            "No setup fee - easy signup",
          ].map((item) => (
            <div className="feature-item" key={item}>
              <div className="feature-icon">
                <Check className="check" />
              </div>
              <span>{item}</span>
            </div>
          ))}
        </div>

        {showStartNowButton && (
          <button
            type="button"
            className="start-now-btn"
            onClick={(e) => {
              e.preventDefault();
              navigate(startNowButtonPath);
            }}
          >
            Start Now
          </button>
        )}
      </div>
    </div>
  );
};

export default LeftContent;

